import { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsAuth, getAdminProfile, useGetMyProfileQuery, clearAuthAndRedirect } from '@/entities/Admin';
import { useChatSocketLifecycle } from '@/features/Chat';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import { routerPath } from '@/shared/config/router';

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAuth = useSelector(getIsAuth);
  const profile = useSelector(getAdminProfile);
  const accessToken = LocalStorageService.getAccessToken();
  const location = useLocation();

  useGetMyProfileQuery(undefined, { skip: !accessToken || !!profile });
  useChatSocketLifecycle();

  useEffect(() => {
    if (!accessToken && !isAuth) {
      clearAuthAndRedirect(routerPath.login);
    }
  }, [accessToken, isAuth]);

  if (!isAuth && !accessToken) {
    return <Navigate to={routerPath.login} state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
};


